export default "__VITE_ASSET__UTTUrF36__"